import { render, staticRenderFns } from "./SpecialistCertificationFindingWrapper.vue?vue&type=template&id=bff005fc"
import script from "./SpecialistCertificationFindingWrapper.vue?vue&type=script&lang=js"
export * from "./SpecialistCertificationFindingWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff005fc')) {
      api.createRecord('bff005fc', component.options)
    } else {
      api.reload('bff005fc', component.options)
    }
    module.hot.accept("./SpecialistCertificationFindingWrapper.vue?vue&type=template&id=bff005fc", function () {
      api.rerender('bff005fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/SpecialistCertificationFindingWrapper.vue"
export default component.exports